// extracted by mini-css-extract-plugin
export default {"root":"Alert_root__MhpIc","green":"Alert_green__oIAcp"};